import React, { useState, useMemo } from "react";
import { useContent } from "../context/ContentContext";
import { resolveImg } from "../services/api";
import { Dialog, DialogContent } from "../components/ui/dialog";

const Gallery = () => {
  const { content } = useContent();
  const g = content.galleryPage;
  const items = g.items || [];
  const [active, setActive] = useState("All");
  const [selected, setSelected] = useState(null);

  const filters = useMemo(() => {
    const cats = Array.from(new Set(items.map((i) => i.category)));
    return ["All", ...cats];
  }, [items]);

  const filtered = useMemo(
    () => (active === "All" ? items : items.filter((i) => i.category === active)),
    [active, items]
  );

  return (
    <div>
      <section className="bg-ink-gradient py-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="text-[#E7C766] font-bold text-sm uppercase tracking-widest">{g.eyebrow}</span>
          <h1 className="font-display font-extrabold text-4xl md:text-5xl text-white mt-3">{g.title}</h1>
          <p className="text-neutral-300 mt-4 max-w-2xl mx-auto">{g.subtitle}</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-2.5 mb-10">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                className={`px-5 py-2 rounded-full text-sm font-semibold border transition-colors ${
                  active === f
                    ? "bg-[#C9A227] border-[#C9A227] text-white"
                    : "bg-white border-neutral-200 text-neutral-700 hover:border-[#C9A227] hover:text-[#C9A227]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
            {filtered.map((item, i) => (
              <button
                key={i}
                onClick={() => setSelected(item)}
                className="group mb-4 block w-full break-inside-avoid rounded-xl overflow-hidden relative"
              >
                <img src={resolveImg(item.image)} alt={item.title} className="w-full object-cover img-zoom" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <div className="text-left">
                    <div className="text-[#E7C766] text-xs font-bold uppercase tracking-wider">{item.category}</div>
                    <div className="text-white font-semibold">{item.title}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={!!selected} onOpenChange={() => setSelected(null)}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden bg-black border-0">
          {selected && (
            <div>
              <img src={resolveImg(selected.image)} alt={selected.title} className="w-full max-h-[75vh] object-contain" />
              <div className="p-4 bg-[#14171c]">
                <div className="text-[#E7C766] text-xs font-bold uppercase tracking-wider">{selected.category}</div>
                <div className="text-white font-semibold">{selected.title}</div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Gallery;
